import RemoveUserFromWorkspace from './RemoveUserFromWorkspace';
export default RemoveUserFromWorkspace;
